import Avatar from '@/components/avatar'
import DisplayName from '@/components/display-name'
import Username from '@/components/username'
import { cn } from '@/util/cn'
import { IUser } from '@giphy/js-types'
import Link from 'next/link'

type Props = {
    user: IUser
    className?: string
    avatarSize?: number
    href?: string
}

const Attribution = ({ user, className, avatarSize = 50, href }: Props) => {
    const containerClassName = cn('group flex gap-2.5', className)
    const children = (
        <>
            <Avatar
                className={cn('rounded-md', href && 'pointer-events-none')}
                href={href}
                user={user}
                size={avatarSize}
            />
            <div className="flex flex-col justify-center font-semibold">
                <DisplayName href={href} user={user} />
                <Username href={href} noLink user={user} className="text-giphyWhite/60 group-hover:underline" />
            </div>
        </>
    )

    if (href)
        return (
            <Link className={containerClassName} href={href}>
                {children}
            </Link>
        )

    return <div className={containerClassName}>{children}</div>
}

export default Attribution
